/**
 * @generated SignedSource<<d372381eb673a4a914252a9b50700e0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNoteTextModePage_widgetNotePage$data = {
  readonly currentValue: string;
  readonly id: string;
  readonly updatedByActorId: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNotePageBackground_widgetNotePage" | "useNoteWidgetStyleText_widgetNotePage">;
  readonly " $fragmentType": "WidgetNoteTextModePage_widgetNotePage";
};
export type WidgetNoteTextModePage_widgetNotePage$key = {
  readonly " $data"?: WidgetNoteTextModePage_widgetNotePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNoteTextModePage_widgetNotePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetNoteTextModePage_widgetNotePage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedByActorId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetNotePageBackground_widgetNotePage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNoteWidgetStyleText_widgetNotePage"
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "78fc19f426ed69deac56d35a0cce58ab";

export default node;
